// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1ckOU","modalFooterButton":"ModalNotes_modalFooterButton__2OTS5"};